var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpenses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.111,
    height: 19.795,
    viewBox: "0 0 20.111 19.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20475",
    "data-name": "Group 20475",
    transform: "translate(-8035.981 -519.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20517",
    "data-name": "Path 20517",
    d: "M113.073,26.249l-13.952.007a3.157,3.157,0,0,0-2.87,3.189v2.983a1.717,1.717,0,0,0,1.716,1.716h3.776V44.99a.686.686,0,0,0,1.171.488l1.332-1.332a.342.342,0,0,1,.484,0l1.394,1.394a1.031,1.031,0,0,0,1.51-.055l1.1-1.277a.342.342,0,0,1,.247-.12.352.352,0,0,1,.257.1l1.356,1.356a1.035,1.035,0,0,0,.728.3h.038a1.029,1.029,0,0,0,.741-.357l1.1-1.277a.343.343,0,0,1,.247-.12.357.357,0,0,1,.257.1l1.294,1.284a.686.686,0,0,0,1.171-.484V29.339a3.094,3.094,0,0,0-3.09-3.09Zm-11.329,7.209H97.968a1.033,1.033,0,0,1-1.03-1.03V29.445a2.466,2.466,0,0,1,2.231-2.5c.055,0,.113-.007.168-.007a2.4,2.4,0,0,1,2.406,2.4ZM115.476,44.99,114.182,43.7a1.048,1.048,0,0,0-.769-.3,1.029,1.029,0,0,0-.741.357l-1.1,1.277a.342.342,0,0,1-.247.12.349.349,0,0,1-.257-.1l-1.356-1.356a1.035,1.035,0,0,0-.728-.3h-.038a1.029,1.029,0,0,0-.741.357l-1.1,1.277a.345.345,0,0,1-.5.021l-1.394-1.394a1.03,1.03,0,0,0-1.456,0l-1.328,1.339V29.339a3.069,3.069,0,0,0-.906-2.187,2.882,2.882,0,0,0-.24-.216h11.789a2.406,2.406,0,0,1,2.4,2.4Z",
    transform: "translate(7939.829 493.751)",
    fill: "#363636",
    stroke: "#363636",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20518",
    "data-name": "Path 20518",
    d: "M324.093,114.437H331.3a.343.343,0,0,0,0-.687h-7.209a.343.343,0,1,0,0,.687Z",
    transform: "translate(7721.257 409.683)",
    fill: "#363636",
    stroke: "#363636",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20519",
    "data-name": "Path 20519",
    d: "M324.093,201.937H331.3a.343.343,0,0,0,0-.687h-7.209a.343.343,0,1,0,0,.687Z",
    transform: "translate(7721.257 325.616)",
    fill: "#363636",
    stroke: "#363636",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20520",
    "data-name": "Path 20520",
    d: "M324.093,289.437H331.3a.343.343,0,0,0,0-.687h-7.209a.343.343,0,1,0,0,.687Z",
    transform: "translate(7721.257 241.549)",
    fill: "#363636",
    stroke: "#363636",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20521",
    "data-name": "Path 20521",
    d: "M324.093,376.937H331.3a.343.343,0,0,0,0-.687h-7.209a.343.343,0,0,0,0,.687Z",
    transform: "translate(7721.257 157.482)",
    fill: "#363636",
    stroke: "#363636",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenses);
export default __webpack_public_path__ + "static/media/Expenses.80c7fc3bdbfb30a9a3959595a78cfb81.svg";
export { ForwardRef as ReactComponent };